import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = { type: String };

  connect() {
    this.format();
  }

  format() {
    if (this.typeValue === 'cpf') {
      this.formatCpf();
    } else if (this.typeValue === 'phone') {
      this.formatPhone();
    }
  }

  formatCpf() {
    const digits = this.element.value.replace(/\D/g, '').slice(0, 11);
    const parts = [];

    if (digits.length > 0) parts.push(digits.slice(0, 3));
    if (digits.length > 3) parts.push(digits.slice(3, 6));
    if (digits.length > 6) parts.push(digits.slice(6, 9));

    this.element.value = parts.join('.') + (digits.length > 9 ? `-${digits.slice(9)}` : '');
  }

  formatPhone() {
    const digits = this.element.value.replace(/\D/g, '').slice(0, 11);
    const areaCode = digits.slice(0, 2);
    const number = digits.slice(2);
    const prefixLength = number.length > 8 ? 5 : 4;
    const prefix = number.slice(0, prefixLength);
    const suffix = number.slice(prefixLength);

    this.element.value = areaCode.length === 2 ? `(${areaCode}) ${prefix}` : areaCode;
    if (suffix) this.element.value += `-${suffix}`;
  }
}
